<div class="card bg-light h-100 border-0 shadow-none card-model">
  <div class="card-body d-flex flex-column">
    <div class="d-flex mb-3 align-items-center gap-3">
      <i class="bi bi-boxes fs-20"></i>
      <h3 class="m-0">{{ model()?.modelName }}</h3>
      <!-- <div class="ms-auto">
        <span class="bi bi-trash3 fs-16 text-danger me-3" role="button" (click)="remove()"></span>
        <span class="bi bi-pencil-square fs-16" role="button" (click)="editModel()"></span>
      </div> -->
    </div>

    <div class="flex-fill h-100 me-n3 mxh-200 overflow-y-auto pe-2 d-flex flex-column gap-3 mb-3">
      @for (elevation of model()?.elevations?.slice(0, 2); track elevation.elevationId || $index) {
        <div class="bg-white shadow-sm fs-14 p-3 py-2 rounded-3 d-flex align-items-center">
          <div class="d-flex flex-column">
            <span class="fw-500">{{ elevation.elevationCode }}</span>
            <span>{{ elevation.noOfBaths }} BR . {{ elevation.noOfHalfBaths }} BA . {{ elevation.area }} sq ft</span>
          </div>
          @if (elevation.amount) {
            <span class="text-primary ms-auto fw-500 fs-18">${{ elevation.amount }}</span>
          }
        </div>
      }
    </div>
    @if (model()?.elevations?.length > 2) {
      <span class="fs-14">+{{ model()?.elevations?.length - 2 }} more elevations</span>
    }
    <button class="btn btn-primary btn-h42 ms-auto" (click)="viewElevations()">
      <i class="bi bi-building me-1"></i>View Elevations
    </button>
  </div>
</div>

<ng-template #viewElevationModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header p-3 shadow-sm">
      <div class="d-flex flex-column">
        <h2 class="modal-title mb-0">{{ model()!.modelName }}</h2>
      </div>
      <span (click)="modal.dismiss('Cross click')" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body p-3">
      <div class="row gy-3">
        @for (elevation of model()?.elevations; track elevation.elevationId || elevation.id || $index) {
          <div class="col-md-6">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-1">
                  <h3 class="mb-0"><i class="bi bi-building me-2"></i>{{ elevation.elevationCode }}</h3>
                  @if (elevation.isActive) {
                    <i class="status-online fs-20 text-success ms-auto"></i>
                  } @else {
                    <i class="status-offline fs-20 text-danger ms-auto"></i>
                  }
                </div>
                <div class="d-flex flex-column gap-1 mt-2">
                  <div class="d-flex">
                    <span>{{ elevation.area }} sq ft</span>
                    <span class="ms-auto">
                      <span><i class="bi bi-badge-wc me-2"></i>{{ elevation.noOfBaths }}</span>
                      <span class="ms-3"><i class="bi bi-car-front-fill me-2"></i> {{ elevation.noOfGarages }}</span>
                    </span>
                  </div>
                  <div class="align-items-center">
                    <p class="mb-0">{{ elevation.description }}</p>
                    @if (edit()) {
                      <span class="text-primary fw-500"
                        >$
                        <input-field
                          [type]="'number'"
                          [(ngModel)]="elevationAmounts[elevation.elevationId]"
                          [value]="elevation.amount"
                          [label]="'Price'"
                        >
                        </input-field>
                      </span>
                    } @else {
                      @if (elevation.amount) {
                        <span class="text-primary fw-500">${{ elevation.amount }} </span>
                      }
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-shadow btn-h42" (click)="closeModal()">Cancel</button>
      @if (edit()) {
        <button type="button" class="btn btn-primary btn-h42" (click)="updateElevations()">Save</button>
      }
    </div>
  </div>
</ng-template>
